import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { calcParams } from "../helpers";

export const useGetQueryParams = ({ match, computedMatch }) => {
  const [formParams, setFormParams] = useState({});

  useEffect(
    () => {
      const params = calcParams(match, computedMatch);
      setFormParams({
        ...params
      });
    },
    [match]
  );

  return { ...formParams };
};
